import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { DualBrands } from '../types/dualBrand';
import { getBrandLogoElement } from '../utils';
import { Typography } from './Typography';
import KfhLogoSmall from './svg/KfhLogoSmall';

interface DualBrandOverlayProps {
  brand: DualBrands;
}

const StyledDualBrandOverlay = styled.div<{ brand: DualBrands }>`
  ${({ theme: { space, layers }, brand }) => css`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: ${layers.galleryOverlay};
    padding: ${space.md};
    display: flex;
    align-items: center;
    gap: ${space.md};

    svg {
      height: 24px;
      width: auto;
      flex-shrink: 0;
    }

    svg + svg {
      padding-left: ${space.md};
      border-left: 1px solid #fff;
    }

    /* Brand-specific gradients */
    ${brand === 'Draker' &&
    css`
      background: linear-gradient(90deg, #0d3745 25%, rgba(13, 55, 69, 0.05) 100%);
    `}
  `}
`;

export const DualBrandOverlay: FC<DualBrandOverlayProps> = ({ brand }) => (
  <StyledDualBrandOverlay brand={brand}>
    {getBrandLogoElement(brand)}
    <KfhLogoSmall />
  </StyledDualBrandOverlay>
);
